export default __webpack_public_path__ + "static/media/rank-down-arrow-icon.1b2edb9d.svg";